import { Injectable } from '@angular/core';
import { TranslatePipe } from '@app/pipes/translate.pipe';

@Injectable()
export class CategoryTipsSuggestionDescService {
  categoryTips = [
    {
      value: 'køkkeninstallation',
      content: [
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.KITCHEN_MOUNTING.1',
        ),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.KITCHEN_MOUNTING.2',
        ),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.KITCHEN_MOUNTING.3',
        ),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.KITCHEN_MOUNTING.4',
        ),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.KITCHEN_MOUNTING.5',
        ),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.KITCHEN_MOUNTING.6',
        ),
      ],
    },
    {
      value: 'græsplæne og græsslåning',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.LAWN_SERVICES.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.LAWN_SERVICES.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.LAWN_SERVICES.3'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.LAWN_SERVICES.4'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.LAWN_SERVICES.5'),
      ],
    },
    {
      value: 'brolægning',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.PAVING.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.PAVING.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.PAVING.3'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.PAVING.4'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.PAVING.5'),
      ],
    },
    {
      value: 'fliselægning',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.TILLING.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.TILLING.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.TILLING.3'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.TILLING.4'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.TILLING.5'),
      ],
    },
    {
      value: 'vinduespudsning',
      content: [
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.WINDOW_CLEANING.1',
        ),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.WINDOW_CLEANING.2',
        ),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.WINDOW_CLEANING.3',
        ),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.WINDOW_CLEANING.4',
        ),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.WINDOW_CLEANING.5',
        ),
      ],
    },
    {
      value: 'havearbejde',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.GARDEN.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.GARDEN.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.GARDEN.3'),
      ],
    },
    {
      value: 'hækklipning',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.HEDGE_TRIMMING.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.HEDGE_TRIMMING.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.HEDGE_TRIMMING.3'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.HEDGE_TRIMMING.4'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.HEDGE_TRIMMING.5'),
      ],
    },
    {
      value: 'flyttehjælp',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.MOVING.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.MOVING.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.MOVING.3'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.MOVING.4'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.MOVING.5'),
      ],
    },
    {
      value: 'rengøring',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CLEANER.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CLEANER.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CLEANER.3'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CLEANER.4'),
      ],
    },
    {
      value: 'møbelsamling',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CLEANER.1'),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.FURNITURE_COLLEC.2',
        ),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.FURNITURE_COLLEC.3',
        ),
        this.translatePipe.transform(
          'PAGES.CREATE_TASK.TIPS.FURNITURE_COLLEC.4',
        ),
      ],
    },
    {
      value: 'skillevæg',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CLEANER.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.PARTITION_WALL.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.PARTITION_WALL.3'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.PARTITION_WALL.4'),
      ],
    },
    {
      value: 'maler',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CLEANER.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.PAINTER.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.PAINTER.3'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.PAINTER.4'),
      ],
    },
    {
      value: 'murer',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CLEANER.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.BRICK_LAYER.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.BRICK_LAYER.3'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.BRICK_LAYER.4'),
      ],
    },
    {
      value: 'tømrer  snedker',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CLEANER.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CARPENTER.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CARPENTER.3'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CARPENTER.4'),
      ],
    },
    {
      // TEMP Solution to double tag is taking care of on DB lvl
      value: 'tømrer & snedker',
      content: [
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CLEANER.1'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CARPENTER.2'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CARPENTER.3'),
        this.translatePipe.transform('PAGES.CREATE_TASK.TIPS.CARPENTER.4'),
      ],
    },
  ];

  constructor(private translatePipe: TranslatePipe) {}

  /**
   * Helper method for finding Category Tips Description in CreateTaskFlow
   * To Help the user get instruction tips for writing better descriptions
   */
  findCatTipsDescription(tagNames: string[] = []) {
    if (tagNames.length > 0) {
      return this.categoryTips.filter((x) => tagNames.includes(x.value));
    }
  }
}
